var siteCode = {

	// hash-menüként megjelölt menüknél a slugot hashként értelmezi
	mainmenuJumpToHash: function () {
		$(".body-index #mainmenu .menu-hash a").each(function () {
			var menuItem = $(this);
			menuItem.attr("href", menuItem.attr("href").replace("/", "#"));

			menuItem.on("click", function (e) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $( $.attr(this, 'href') ).offset().top
				}, 500);
				return false;
			});
		});
	},

	hightlightAnim: function () {
		if ($(".body-index").length <= 0) { return false; }		// ha nem nyitóról nézzük, nem fut le

		var entries = $("#highlight .portlet-entry"),			// rotálandó ejegyzések
			counter = 0,										// aktuális bejegyzés
			timer,												// időzítő
			delay = 1000,
			duration = 20000;

		function loopInit() {
			entries.css({
				left: -250
			});
			timer = setInterval(function () {
				//loopStart(counter++);
				cloneLoopStart(counter++);
				if (counter >= entries.length) { counter = 0; }
			}, delay);
		}

		function cloneLoopStart(current) {

			var elem = entries.eq(current).clone(),
				vShift = (Math.random() * 150) * (Math.round(Math.random()) * 2 - 1),
				scale = ((Math.random() * 5) + 7) / 10,
				opacity = (Math.round(Math.random() * 6) + 5) / 10;

			elem.appendTo(entries.eq(entries.length - 1).parent());

			console.log("margin-top", vShift, scale);

			elem.css({
				"margin-top": vShift,
				"transform": "scale(" + scale + ", " + scale + ")",
				"-moz-transform": "scale(" + scale + ", " + scale + ")",
				"-webkit-transform": "scale(" + scale + ", " + scale + ")",
				"opacity": opacity,
				"-moz-opacity": opacity,
				"-webkit-opacity": opacity
			});

			elem.animate({
				left: "120%"
			}, duration, "swing", function () {
				elem.remove();
			});
		}

		/*function loopStart(current) {

			entries.eq(current).animate({
				left: "120%"
			}, duration, "swing", function () {
				entries.eq(current).css({
					left: -200,
					"margin-top": -100
				})
			});
			console.log(current);
		}*/

		loopInit();
	}
};
